import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

// Slim Roboto font imports: only required weights (400,500,700)
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import CssBaseline from "@material-ui/core/CssBaseline";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import "./index.css";
import App from "./App/App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import useStore from './components/Base/Store';

import { AuthContextProvider } from "../src/components/Auth/AuthContext";
import LoadingBackdrop from "./components/UI/Controls/LoadingBackdrop";
import { initGoogleAnalyticsEventTracking } from "./components/Base/useGoogleAnalytics";

// Note: We intentionally avoid mutating native Date behavior to satisfy lint and ensure safety.

// Global IST Date utilities (safer approach than overriding Date)
window.ISTDate = function(...args) {
    if (args.length === 0) {
        // For current date/time in IST
        const now = new Date();
        const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
        const ist = new Date(utc + (5.5 * 3600000)); // IST is UTC+5:30
        return ist;
    } else {
        // For specific date - assume it's meant to be IST
        return new Date(...args);
    }
};

// Helper functions for IST operations
window.getISTDate = function() {
    return new Date().toLocaleString('en-CA', {
        timeZone: 'Asia/Kolkata',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).split(',')[0];
};

window.getISTDateTime = function() {
    return new Date().toLocaleString('en-IN', {
        timeZone: 'Asia/Kolkata',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });
};
if (typeof process !== 'undefined' && process.env) {
  process.env.TZ = 'Asia/Kolkata';
}

// Removed unsafe Date.prototype override. Use window.getISTDate / window.getISTDateTime helpers instead.


const customTheme = createTheme({
  palette: {

    // DEEP PURPLE 311b92
    //  primary: {
    //    main: '#311b92',
    //    light:'#6746c3',
    //    dark:'#000063',
    //    contrastText: '#ffffff',
    //  },
    //  secondary: {
    //   main: '#9fa8da',
    //   light:'#d1d9ff',
    //   dark:'#6f79a8',
    //   contrastText: '#000000',
    // },

    // PURPLE THEME
    primary: {
      main: '#232F3E',
      light: '#ffffff',
      dark: '#131921',
      contrastText: '#F7F7F7',
    },
    secondary: {
      main: '#205BD4',
      light: '#F0F8FF',
      dark: '#0d47a1',
      highlight : '#61AFFE',
      contrastText: '#F7F7F7',
    },

    success: {
      main: '#4caf50',
      light: '#c8e6c9',
      dark: '#1b5e20',
      contrastText: '#000050',
    },

    //  secondary: {
    //   main: '#e1bee7',
    //   light:'#fff1ff',
    //   dark:'#af8eb5',
    //   contrastText: '#000000',
    // },  

    //BLUE THEME
    // primary: {
    //   light: '#9a67ea',
    //   main: '#673ab7',
    //   dark: '#320b86',
    //   contrastText: '#ffffff',
    // },
    // secondary: {      
    //   light: '#60ad5e',
    //   main: '#2e7d32', 
    //   dark: '#005005',
    //   contrastText: '#fff',      
    // },

  },
  // breakpoints: {
  //   values: {
  //     xs: 0,
  //     sm: 640,
  //     md: 900,
  //     lg: 1200,
  //     xl: 1536,
  //     mobile: 0,
  //     tablet: 640,
  //     laptop: 1024,
  //     desktop: 1200,
  //   },
  // },
  typography: {
    button: {
      textTransform: "none",
    },
  },
});

// Initialize Google Analytics event tracking
initGoogleAnalyticsEventTracking();

ReactDOM.render(
  <>
    <CssBaseline />
    <ThemeProvider theme={customTheme}>
      <Suspense fallback={<LoadingBackdrop open={true} />}>
        <AuthContextProvider>
          <BrowserRouter
            getUserConfirmation={() => {
              /* Empty callback to block the default browser prompt */
            }}
          >
            <App />
          </BrowserRouter>
        </AuthContextProvider>
      </Suspense>
    </ThemeProvider>
  </>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// Wire CRA SW update hook to our update dialog
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    try {
      const setAppVersionCheck = useStore.getState().setAppVersionCheck;
      setAppVersionCheck(true);
      // Attach the registration for UpdateApp to access if needed
      window.__ezybillSWReg = registration;
    } catch (_) {
      // ignore
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
